import { Section, ButtonLink } from "../components/ui";
import { SmartLink } from "../components/SmartLink";
import { NAV_LINKS } from "../data/nav";

/**
 * Cloudflare Pages rewrites unknown paths to /index.html with a 200, so
 * this renders in place of a real 404 status. That is the standard SPA
 * tradeoff; the mitigation is that every genuine route is prerendered to
 * its own file, so a crawler only reaches this component for paths that
 * really do not exist.
 */
export function NotFound() {
  return (
    <Section>
      <div className="container max-w-2xl py-16 text-center">
        <div className="font-mono text-sm tracking-[0.2em] text-white/30">404</div>
        <h1 className="mt-4 font-display text-[2rem] font-bold leading-tight tracking-tight sm:text-4xl">
          That page isn't here.
        </h1>
        <p className="mx-auto mt-4 max-w-md text-[15px] leading-relaxed text-white/60">
          It may have moved when we rebuilt the site. Everything is one of
          these:
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-2">
          {NAV_LINKS.map((l) => (
            <SmartLink
              key={l.href}
              href={l.href}
              className="rounded-full border border-white/10 bg-white/[0.04] px-3.5 py-1.5 text-sm text-white/75 transition-colors hover:border-white/25 hover:text-white"
            >
              {l.label}
            </SmartLink>
          ))}
        </div>

        <div className="mt-9 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <ButtonLink href="/">Back to the homepage</ButtonLink>
          <ButtonLink href="/contact" variant="ghost" icon={false}>
            Talk to us
          </ButtonLink>
        </div>
      </div>
    </Section>
  );
}
